// extracted by mini-css-extract-plugin
export default {"header":"header-new_header__bQV6y","inner":"header-new_inner__3yswZ","logo":"header-new_logo__7Il7m"};